<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" >
      <b-col cols="10">
        <b-form inline>
          <b-form-input
            style="min-width:150px;"
            class="m-1"
            placeholder="说明"
            v-model="queryParam.criteria.keywords"
          ></b-form-input>

          <b-button variant="outline-primary" @click="handleQuery" class="m-1">查询</b-button>
        </b-form>
      </b-col>
    </b-row>

    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        responsive
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>   

  </div>
</template>

<script>
import * as transFacade from "../../../api/trans-facade.js";
export default {
  // validations:
  props:{
    orgId: String,
  },
  data() {
    return {
      fields: [
        {
          key: "createTime",
          label: "交易时间"
        },
        {
          key: "itemName",
          label: "内容"
        },
        {
          key: "amount",
          label: "金额"
        },
        {
          key: "balanceAmount",
          label: "余额"
        },
        {
          key: "desc",
          label: "说明"
        }
      ],
      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 20,
        page: 1,
        criteria: {
          orgId: this.orgId,
          keywords: "",
        },
        sortOrder: { createTime: "descending" }
      },
      pageLoading: false,
      tableLoading: false, // 表格Loading状态
      showAlert: false,


    }
  },

  created() {},
  mounted() {
    // 异步加载列表数据
    this.handleQuery();

  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    // 异步加载列表数据
    list(page) {
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      transFacade
        .pageList(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    handleQuery(){
      this.list()
    },


  },


};
</script>

<style >
</style>
